import { useEffect } from 'react';
import { useLazyDataModel } from '@thd-nucleus/data-sources';

export const useMultipleSamples = ({
  page, parentId, sampleLimit, storeId, zipCode
}) => {
  const [metaReq, metadataResponse] = useLazyDataModel('sampleProductsMetadata', {
    ssr: false,
    variables: {
      parentId
    }
  });

  useEffect(() => {
    if (parentId) {
      metaReq({ variables: { parentId } });
    }
  }, [parentId]);

  const childItems = metadataResponse?.data?.metadata?.childItemsLookup || [];
  const pageStart = page * +sampleLimit;
  const pageEnd = pageStart + +sampleLimit;
  const itemIds = childItems
    .filter((item) => !!item.itemId)
    .map((item) => item.itemId).slice(pageStart, pageEnd);

  const [productRequest, productResponse] = useLazyDataModel('products', { variables: {
    itemIds
  } });

  useEffect(() => {
    if (itemIds?.length) {
      productRequest({ variables: { itemIds } });
    }
  }, [itemIds?.length]);

  const { products } = productResponse?.data || {};
  const sampleIdsSet = new Set((products || [])
    .filter((product) => !!product?.identifiers?.sampleId)
    .map((product) => product?.identifiers?.sampleId));

  const sampleIds = [...sampleIdsSet];

  const [sampleRequest, samplesResponse] = useLazyDataModel('sampleProducts', {
    variables: {
      itemIds: sampleIds,
      storeId,
      zipCode
    }
  });

  useEffect(() => {
    if (storeId && sampleIds?.length) {
      sampleRequest({
        variables: {
          itemIds: sampleIds,
          storeId,
          zipCode
        }
      });
    }
  }, [sampleIds?.length, storeId]);

  const normalizeImageUrl = (url, size) => {
    const urlRE = /<SIZE>/i;
    return url.replace(urlRE, size);
  };

  const { products: sampleProducts } = samplesResponse?.data || {};
  let orderSamples;
  if (sampleProducts && sampleProducts.length) {
    orderSamples = sampleProducts.map((product) => {
      const {
        availabilityType, fulfillment, identifiers, media, pricing, specificationGroup
      } = product || {};
      const { itemId } = identifiers || {};
      const details = specificationGroup?.find((spec) => spec.specTitle === 'Details');
      let color = details?.specifications?.find((spec) => spec.specName === 'Color/Finish')?.specValue;

      // only want to to do this if we do not have a Color/Finish
      if (!color) {
        color = details?.specifications?.find((spec) => spec.specName === 'Color Family')?.specValue;
      }

      const imageObject = media?.images.find((image) => image.subType === 'PRIMARY');
      const imgUrl = imageObject?.url;
      const imgSize = imageObject?.sizes.find((size) => size === '400');
      const isFulfillable = !!(fulfillment?.fulfillmentOptions || [])
        .find((option) => option.fulfillable);
      const discontinued = availabilityType?.discontinued;
      const price = pricing?.value;

      return {
        itemId,
        color,
        imgUrl: normalizeImageUrl(imgUrl, imgSize),
        inStockStatus: isFulfillable,
        discontinued,
        price
      };
    });
  }

  const totalPages = Math.ceil((childItems || []).length / sampleLimit);

  return {
    data: { orderSamples, totalPages },
    loading: productResponse?.loading || metadataResponse?.loading || samplesResponse?.loading,
    error: productResponse?.error || metadataResponse?.error || samplesResponse?.error,
  };
};
